/** This export is automatically generated */
export const isoNow = '2025-06-04T08:30:18.931Z';
